export enum SupportedRegionTypes {
    Brand = "Brand",
    SearchBox = "SearchBox",
    QuickLinks = "QuickLinks",
    Checkout = "Checkout",
    CountryLangSelector = "CountryLangSelector",
    Favourites = "Favourites",
    ShoppingBag = "ShoppingBag",
    PrimaryNav = "PrimaryNav",
    BurgerMenu = "BurgerMenu",
    TabbedDepartment = "TabbedDepartment",
    BackToSiteBanner = "BackToSiteBanner",
    StaticBannerLinks = "StaticBannerLinks",
    SecureHelp = "SecureHelp",
    SecureIcon = "SecureIcon",
    MessageBanner = "MessageBanner",
}

export enum SupportedRegionSubTypes {
    Link = "link",
    MyAccount = "MyAccount",
}
